import React from "react";
import { Check, Circle, Loader2 } from "lucide-react";

/**
 * Timeline - Renders the RFQ pipeline stages.
 * Props:
 *  - stages: [{ key, label, status: 'done'|'in_progress'|'pending', at }]
 */
export default function Timeline({ stages, testId }) {
  return (
    <ol data-testid={testId} className="relative">
      {stages.map((s, i) => {
        const isLast = i === stages.length - 1;
        const done = s.status === "done";
        const active = s.status === "in_progress";
        return (
          <li key={s.key} className="relative pl-12 pb-8">
            {/* connector */}
            {!isLast && (
              <span
                className={`absolute left-[15px] top-8 bottom-0 w-px ${
                  done ? "bg-[hsl(217,90%,25%)]" : "bg-neutral-200"
                }`}
              />
            )}
            {/* dot */}
            <span
              className={`absolute left-0 top-0 grid place-items-center w-8 h-8 rounded-full border ${
                done
                  ? "bg-[hsl(217,90%,25%)] border-[hsl(217,90%,25%)] text-white"
                  : active
                  ? "bg-white border-[hsl(217,90%,32%)] text-[hsl(217,90%,35%)]"
                  : "bg-white border-neutral-300 text-neutral-400"
              }`}
              data-testid={`timeline-stage-${s.key}`}
            >
              {done ? (
                <Check className="w-4 h-4" strokeWidth={2.5} />
              ) : active ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Circle className="w-3 h-3" />
              )}
            </span>
            <div className="min-h-[32px] flex flex-col justify-center">
              <div
                className={`text-sm font-medium ${
                  done
                    ? "text-neutral-900"
                    : active
                    ? "text-[hsl(217,90%,25%)]"
                    : "text-neutral-500"
                }`}
              >
                {s.label}
              </div>
              <div className="text-xs text-neutral-500 mt-0.5">
                {done && s.at ? new Date(s.at).toLocaleString() : active ? "In progress" : "Pending"}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
